/**
 * Загрузка кусков приложения, переживающая обновление системы.
 *
 * Разделы приезжают отдельными файлами, а имя файла содержит хэш содержимого.
 * После обновления имена меняются, и у вкладки, открытой до него, на руках
 * остаются адреса, которых больше нет. Человек в этот момент не делает ничего
 * особенного — просто открывает раздел, — и получает пустой экран.
 *
 * Единственное лекарство — взять новую версию страницы. Перезагрузка
 * разрешается один раз за сеанс: если файл не грузится по другой причине
 * (нет сети, сломанный прокси), бесконечная перезагрузка сделает только хуже.
 */

const RELOADED = "pt-chunk-reloaded";

export async function chunk<T>(load: () => Promise<T>): Promise<T> {
  try {
    const module = await load();
    // Загрузилось — значит, прошлая перезагрузка помогла и счётчик можно снять
    try {
      sessionStorage.removeItem(RELOADED);
    } catch {
      // Приватный режим и запрет на хранилище: это не повод падать
    }
    return module;
  } catch (error) {
    let reloadedAlready = true;
    try {
      reloadedAlready = sessionStorage.getItem(RELOADED) !== null;
      sessionStorage.setItem(RELOADED, "1");
    } catch {
      reloadedAlready = true;
    }

    if (reloadedAlready) {
      throw error;
    }

    window.location.reload();
    // Перезагрузка не мгновенна: до неё компонент не должен ни отрисоваться,
    // ни сообщить об ошибке
    return new Promise<T>(() => undefined);
  }
}
